"use strict";
/**
 * @module Client
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var command_header_1 = require("./../services/command-header");
var logger = require("./../util/logger");
var log = logger.create('ServiceLocator');
/**
 * A class allowing to locate services and create {@link ServiceSender}s for them
 */
var ServiceLocatorImpl = /** @class */ (function () {
    /**
     * Create a new ServiceLocator instance
     *
     * @param internalSession  the internal session
     * @param serialisers      the map of serialisers
     * @param serviceAdapter   the service adapter
     */
    function ServiceLocatorImpl(context, serviceAdapter) {
        this.context = context;
        this.serviceAdapter = serviceAdapter;
    }
    /**
     * Obtain a service from a service definition
     *
     * @param service  the service definition
     * @return         a sender that allows to send requests for the service
     */
    ServiceLocatorImpl.prototype.obtain = function (service) {
        var _this = this;
        var requestSerialiser = service.request;
        var responseSerialiser = service.response;
        var reference = {
            send: function (req, callback) {
                if (callback === void 0) { callback = function () { }; }
                return __awaiter(_this, void 0, void 0, function () {
                    var handler, conversations, conversationId;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                handler = {
                                    onOpen: function (cid) {
                                        var header = new command_header_1.CommandHeader(service.id, cid);
                                        try {
                                            _this.serviceAdapter.sendRequest(header, req, requestSerialiser);
                                        }
                                        catch (e) {
                                            callback(e);
                                            throw e;
                                        }
                                    },
                                    onResponse: function (cid, input) {
                                        var response;
                                        try {
                                            response = responseSerialiser.read(input);
                                        }
                                        catch (e) {
                                            log.debug("Failed to deserialise response from service " + service.id, e.stack);
                                            callback(e);
                                            return true;
                                        }
                                        try {
                                            callback(null, response);
                                        }
                                        catch (e) {
                                            log.debug("Request callback for service '" + service.id + "' threw an error", e.stack);
                                            try {
                                                callback(e);
                                            }
                                            catch (e) {
                                                log.debug("Failed to notify callback error for service '" + service.id + "'", e);
                                            }
                                        }
                                        return true;
                                    },
                                    onDiscard: function (cid, err) {
                                        callback(err);
                                    }
                                };
                                conversations = this.context.getConversationSet();
                                return [4 /*yield*/, conversations.newConversation(handler)];
                            case 1:
                                conversationId = _a.sent();
                                return [2 /*return*/, function () {
                                        conversations.discard(conversationId, new Error('Cancelled'));
                                    }];
                        }
                    });
                });
            }
        };
        return reference;
    };
    return ServiceLocatorImpl;
}());
exports.ServiceLocatorImpl = ServiceLocatorImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/client/service-locator.js
// module id = 511
// module chunks = 1